import React from "react";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { Switch } from "../ui/switch";
import { useRouter } from "next/router";
import { Locales } from "~/i18n/i18n-types";
import { RTL_LOCALES } from "~/utils/constants";

const DarkModeBtn = () => {
	const { setTheme, theme } = useTheme();

	const handleThemeChange = (bool: boolean) => {
		setTheme(!bool ? "light" : "dark");
	};

	const { locale: nextLocale } = useRouter();
	const locale = (nextLocale ?? "en") as Locales;
	const isRtl = RTL_LOCALES.includes(locale);

	return (
		<Switch
			title={theme === "dark" ? "switch to light mode" : "switch to dark mode"}
			aria-label="dark mode"
			checked={theme === "dark"}
			onCheckedChange={handleThemeChange}
			disabled={theme === "contrast"}
			dir={isRtl ? "rtl" : "ltr"}
		>
			{theme === "dark" ? (
				<MoonIcon size={14} role="presentation" />
			) : (
				<SunIcon size={14} role="presentation" />
			)}
		</Switch>
	);
};

export default DarkModeBtn;
